import { render, staticRenderFns } from "./ListWorkItemPage.vue?vue&type=template&id=344c8fa8&"
import script from "./ListWorkItemPage.vue?vue&type=script&lang=js&"
export * from "./ListWorkItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports